/**
 * IMPORTS
 */

import { useEffect, useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

// store-zustand
import { useStoreZustandManageClient } from "@/store-zustand/manage-client/manege-client";
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { USER_QUERY_STALE_TIME } from "@/common/const/query-cache";
// use-cases
import { handleGetCustomers } from "@/domain/use-cases/cutomers";

import { generatePagination } from "./helpers/generate-pagination";
// helpers
import { mapRemessasToTable } from "./helpers/map-remessa-to-table";
// typings
import { IManageClientesponse } from "./interface";

function useManageClient() {
  const { currentPage, itemsPerPage, searchItem, setPaginations, setLastPage, setTotalItemsPage } =
    useStoreZustandManageClient();

  const { token: accessToken } = useStoreZustandUserAuth();

  // Chave de cache única baseada na página atual e na quantidade de itens por página
  const queryKey = ["clientes", currentPage, itemsPerPage, searchItem];

  const {
    isLoading,
    error: isError,
    data: customersResponse,
  } = useQuery<IManageClientesponse>({
    queryKey,
    queryFn: async () => {
      const response = (await handleGetCustomers(
        accessToken!,
        currentPage,
        itemsPerPage,
        searchItem!
      )) as IManageClientesponse;

      return response;
    },
    staleTime: USER_QUERY_STALE_TIME,
  });

  const clients = mapRemessasToTable(customersResponse?.data as any);
  const pagination = customersResponse?.pagination;

  // só recalcula se currentPage ou last_page mudar
  const pages = useMemo(() => {
    return generatePagination(currentPage, pagination?.last_page ?? 1);
  }, [currentPage, pagination?.last_page]);

  // atualiza Zustand uma única vez
  useEffect(() => {
    setPaginations(pages as number[]);
    setLastPage(pagination?.last_page);
    setTotalItemsPage(Number(pagination?.total));
  }, [pages, setPaginations, setLastPage, pagination, setTotalItemsPage]);

  return {
    clientes: clients ?? [],
    paginations: pages,
    isLoading,
    isError,
  };
}

/**
 * EXPORTS
 */
export { useManageClient };
